import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import androidWidgetService from '../services/androidWidget.service';
import { isZeedcomNativeApp, publishNativeWidgetSnapshot } from '../utils/nativeShell';

let inflight: Promise<void> | null = null;
let queued = false;

export function pushWidgetSnapshot(): void {
  if (!isZeedcomNativeApp()) return;
  if (inflight) {
    queued = true;
    return;
  }
  const run = () => {
    inflight = androidWidgetService
      .getSummary()
      .then(data => {
        publishNativeWidgetSnapshot(data);
      })
      .catch(() => undefined)
      .finally(() => {
        inflight = null;
        if (!queued) return;
        queued = false;
        run();
      });
  };
  run();
}

export function useWidgetSnapshotSync(): void {
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isAuthenticated || !isZeedcomNativeApp()) return undefined;
    pushWidgetSnapshot();
    const timer = window.setInterval(pushWidgetSnapshot, 60000);
    const onVisible = () => {
      if (document.visibilityState === 'visible') pushWidgetSnapshot();
    };
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      window.clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [isAuthenticated]);
}
